import { shallowCopy } from 'src/app/services/utils'
import { DateRange } from '../../../services/date-utils.service'
import { Assistance } from '../../../models/assistance'

export class RecommendedAssistantsFilter {
  values: IRecommendedAssistantsFilter
  defaults: IRecommendedAssistantsFilter

  constructor(defaults: IRecommendedAssistantsFilter) {
    this.defaults = shallowCopy(defaults)
    this.values = shallowCopy(defaults)
  }

  static createFromAssistance(assistance: Assistance, overrides: Partial<IRecommendedAssistantsFilter> = {}) {
    // TODO make sure client recommendations are added when adding assistant to a recurrence occurrence directly
    // TODO we need to get recurrenceParent from DB

    const defaults: IRecommendedAssistantsFilter = {
      dateFrom: assistance.plannedFrom,
      dateTo: assistance.plannedTo,
      preferredGenderId: assistance.preferredAssistantGenderId
        ? assistance.preferredAssistantGenderId
        : assistance.client?.preferredGenderId,
      needsStrongAssistant: assistance.strongAssistantNeeded
        ? assistance.strongAssistantNeeded
        : assistance.client?.needsStrongAssistant,
      needsAdvancedAssistant: assistance.advancedAssistantNeeded
        ? assistance.advancedAssistantNeeded
        : assistance.client?.needsAdvancedAssistant,
      ...overrides,
    }

    return new RecommendedAssistantsFilter(defaults)
  }

  clear() {
    for (const prop in this.values) {
      if (this.values.hasOwnProperty(prop)) {
        this.values[prop] = null
      }
    }
  }

  resetToDefaults() {
    this.values = shallowCopy(this.defaults)
  }

  getDefaultDateRange(): DateRange {
    return {
      from: new Date(this.defaults.dateFrom),
      to: new Date(this.defaults.dateTo),
    }
  }

  getDateRange(): DateRange {
    return {
      from: new Date(this.values.dateFrom),
      to: new Date(this.values.dateTo),
    }
  }
}

export interface IRecommendedAssistantsFilter {
  dateFrom: string
  dateTo: string
  preferredGenderId: number
  needsStrongAssistant: boolean
  needsAdvancedAssistant: boolean
}
